import { j as t } from "../../../../../node_modules/react/jsx-runtime.js";
import { clsx as s } from "../../../../../node_modules/clsx/dist/clsx.m.js";
import i from "../../../Icon/Icon.js";
import g from "../../../Tooltip/Tooltip.js";
import { Typography as m } from "../../../Typography/Typography.js";
import { memo as x } from "react";
const p = (a) => {
  const { label: n, icon: r, tooltipText: l, disabled: o, status: e = "default", withTextField: f } = a, c = {
    destructive: "text-color-fg-danger-default",
    success: "text-color-fg-success-default",
    warning: "text-color-fg-warning-default",
    default: "text-color-fg-lighter"
  }, d = {
    destructive: "info-circle-filled",
    success: "check-circle-filled",
    warning: "alert-triangle-filled"
  }, u = {
    destructive: "color/fg/danger/default",
    success: "color/fg/success/default",
    warning: "color/fg/lighter",
    default: "color/fg/lighter"
  };
  return /* @__PURE__ */ t.jsxs(
    "div",
    {
      className: s("flex gap-075 items-center", {
        "opacity-40 cursor-not-allowed": o && !f
      }),
      children: [
        r && e == "default" && /* @__PURE__ */ t.jsx(t.Fragment, { children: l && /* @__PURE__ */ t.jsx(
          g,
          {
            title: l,
            disabled: o,
            trigger: /* @__PURE__ */ t.jsx(
              i,
              {
                name: r,
                size: "sm",
                className: s(c[e])
              }
            )
          }
        ) }),
        ["destructive", "success", "warning"].includes(e) && /* @__PURE__ */ t.jsx(
          i,
          {
            name: d[e],
            size: "sm",
            className: s(e && c[e] || "text-color-fg-lighter")
          }
        ),
        /* @__PURE__ */ t.jsx(
          m,
          {
            text: n,
            variant: "interface/default/s",
            textColor: u[e]
          }
        )
      ]
    }
  );
}, y = x(p);
export {
  p as FieldHelperText,
  y as default
};
//# sourceMappingURL=FieldHelperText.js.map
